import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/tours", label: "Tours" },
  { to: "/road-trip", label: "Road Trip" },
  { to: "/#the-table", label: "Fine Dining" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/70 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="font-display font-extrabold text-xl tracking-tighter uppercase">
            Immersion Festival
          </span>
          <span className="hidden sm:block text-[10px] uppercase tracking-[0.3em] text-gray-500 border-l border-white/15 pl-3">
            Iceland · Oct 2026
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-xs uppercase tracking-[0.2em] transition-colors ${
                pathname === l.to ? "text-white" : "text-gray-400 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/tours"
            data-testid="nav-cta"
            className="bg-white text-black hover:bg-gray-200 uppercase tracking-[0.15em] text-xs font-bold py-3 px-6 transition-colors"
          >
            Book Now
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#050505] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm uppercase tracking-[0.2em] text-gray-300"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
